import { Node } from '../types';

export interface Point {
  x: number;
  y: number;
}

/**
 * Computes the average position (centroid) of the given nodes.
 * Returns {0, 0} if nodes is empty.
 */
export function computeCentroid(nodes: Node[]): Point {
  if (nodes.length === 0) return { x: 0, y: 0 };
  const sum = nodes.reduce(
    (acc, n) => ({ x: acc.x + n.position.x, y: acc.y + n.position.y }),
    { x: 0, y: 0 }
  );
  return { x: sum.x / nodes.length, y: sum.y / nodes.length };
}

/**
 * Shifts every node's position by the given delta vector.
 */
export function applyDeltaToNodes<T extends Node>(
  nodes: T[],
  delta: Point
): T[] {
  if (delta.x === 0 && delta.y === 0) return nodes;
  return nodes.map((n) => ({
    ...n,
    position: {
      x: n.position.x + delta.x,
      y: n.position.y + delta.y,
    },
  }));
}
